module.exports = __webpack_public_path__ + "img/word.06b5ec12.svg";